import type { RouteObject } from 'react-router';
import { LandingPage } from './landing-page';

/** Landing comercial do produto em "/". */
export const publicRoutes: RouteObject[] = [{ index: true, element: <LandingPage /> }];
